/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  hashtagModal actions
 */

export const SET_CITY_STATE = '@@nzr/modals/hashtagModal/SET_CITY_STATE'
export const SET_HASHTAG_TYPE = '@@nzr/modals/hashtagModal/SET_HASHTAG_TYPE'
export const SET_RENT_REPORT = '@@nzr/modals/hashtagModal/SET_RENT_REPORT'

export const HASHTAG_TYPES = {
  RENT_REPORT: 'rent-report',
  CITY_GUIDE: 'city-guide',
} as const

const ALLOWED_HASHTAGS = new Set(Object.values(HASHTAG_TYPES))

export function isAllowedHashtag(
  hash: string
): hash is (typeof HASHTAG_TYPES)[keyof typeof HASHTAG_TYPES] {
  return ALLOWED_HASHTAGS.has(hash)
}
